import { render } from "./AllSubjects.vue?vue&type=template&id=213fec40&scoped=true"
import script from "./AllSubjects.vue?vue&type=script&lang=js"
export * from "./AllSubjects.vue?vue&type=script&lang=js"

import "./AllSubjects.vue?vue&type=style&index=0&id=213fec40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213fec40"]])

export default __exports__